import React, { useState } from "react";
import Footer from 'components/footer';
import swal from 'sweetalert';

// import { NavLink } from 'react-router-dom';

const ContactUs = () => {



    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();

        const res = await fetch("https://gabrixportfolio-mern-backend.onrender.com/submitgetintouch", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ firstname, lastname, phone, email, message })
        });

        const data = await res.json();

        if (data.status === 422 || !data) {
            window.alert("Invalid");
            console.log()
        } else {
            // window.alert("Success")
             swal({
                title: "Feedback Sent Successfuly",
                icon: "success",
            })
        };

        setFirstname("");
        setLastname("");
        setPhone("");
        setEmail("");
        setMessage("");

    };



    return (
        <div className='contactUsBody'>

            <div className='contactUsContainerSection1'>

                <section className='contactUsSection1'>

                    <div className='homeContainerSection6'>

                        <section className='homeSection6'>

                            <div data-aos="fade-up" data-aos-offset="200"
                                data-aos-delay="50"
                                data-aos-duration="2000" className='homeSkillsHeadingDiv'>
                                <h1 className="homeFeedbackHeading">Get In Touch</h1>
                            </div>

                            <div data-aos="fade-up" data-aos-offset="200"
                                data-aos-delay="100"
                                data-aos-duration="3000" className='homeFeebackContainer'>

                                <form onSubmit={handleSubmit} className='homeFeebackBox'>

                                    <div className='homeFeedbackInput'>
                                        <input placeholder="aa" type='text' name='firstname' id='feedbackFirstName' required
                                            value={firstname} onChange={(e) => setFirstname(e.target.value)}>

                                        </input>
                                        <label for="feedbackFirstName"> First-Name </label>
                                    </div>
                                    <div className='homeFeedbackInput'>
                                        <input placeholder="aa" type='text' name='lastname' id='feedbackLastName' required
                                            value={lastname} onChange={(e) => setLastname(e.target.value)}>

                                        </input>
                                        <label for="feedbackLastName"> Last-Name </label>
                                    </div>
                                    <div className='homeFeedbackInput'>
                                        <input placeholder="aa" type="number" name='phone' id='feedbackNumber' required
                                            value={phone} onChange={(e) => setPhone(e.target.value)}>

                                        </input>
                                        <label for="feedbackNumber"> Phone Number </label>
                                    </div>
                                    <div className='homeFeedbackInput'>
                                        <input placeholder="aa" type='email' name='email' id='feedbackEmail' required
                                            value={email} onChange={(e) => setEmail(e.target.value)}>

                                        </input>
                                        <label for="feedbackEmail"> E-Mail </label>
                                    </div>

                                    <div className='input5'>
                                        <textarea placeholder="adUGYUAGWCYGYACa" name='message' id='feedbackMsg' required
                                            value={message} onChange={(e) => setMessage(e.target.value)}>

                                        </textarea>
                                        <label for="feedbackMsg">Message </label>
                                    </div>

                                    <div className='homeFeedbackSubmit'>
                                        <div className='servicesBtn'>

                                            <button type='submit'
                                                className='btn'>➜ Submit </button>
                                        </div>
                                    </div>



                                </form>

                            </div>

                        </section>


                    </div>

                </section>

            </div>

            <Footer />

        </div>


    )
};

export default ContactUs;